module.exports = __webpack_public_path__ + "static/assets/01a3b56eef292b43a137f9223b8a4934.png";